import React from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";

function NumberInput({ onChange, onValueChange, customRegex, ...props }) {
  function normalize(value) {
    const regex = customRegex || /[^0-9.-]/g;

    return value.replace(regex, '');
  }

  function handleChange(e) {
    const event = {
      target: {
        value: normalize(e.target.value),
        name: e.target.name
      }
    }

    onChange(event);
    onValueChange(event.target.value);
  }

  return (
    <TextInput
      onChange={handleChange}
      {...props}
    />
  );
}

NumberInput.propTypes = {
  onChange: PropTypes.func,
  onValueChange: PropTypes.func
}

NumberInput.defaultProps = {
  onChange() {},
  onValueChange() {}
}

export default NumberInput;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/NumberInput.js